import { graphql } from "gql.tada";

// QUERIES

const FetchWizardQry = graphql(`
  query ($input: GetWizardInput!) {
    fetchWizard(input: $input) {
      constraints {
        minValue
        maxValue
        scope
        reference
        warningMessage
      }
      languageCode
      nodes {
        id
        parentId
        kind
        position
        folderName
        folderDescription
        originId
        active
      }
      projectNodeId
      projectId
      currentStep
      totalSteps
      availableSteps
      subType
      topology
      fieldKeyGroup
      currentQuestionnaire {
        title
        description
        info
        position
        id
        questions {
          title
          identifier
          position
          description
          info
          iconName
          fieldGroups {
            title
            key
          }
          constraints {
            scope
            reference
            minValue
            maxValue
            warningMessage
          }
          fields {
            title
            fieldGroupId
            fieldKey
            fieldValue
            fieldType
            fieldInputType
            fieldDefaultValue
            fieldMin
            fieldMax
            values
            enabled
            onAction {
              fieldValueChange {
                newValue
                states {
                  fieldKey
                  fieldValue
                  fieldMax
                  fieldMin
                  fieldInputType
                  fieldKeyGroup
                  enabled
                }
              }
            }
            iconName
          }
        }
      }
      questionnaires {
        title
        description
        info
        position
        id
      }
    }
  }
`);

const FetchWizardStepQuestionnaire = graphql(`
  query ($input: GetQuestionnaireInput!) {
    fetchWizardStepQuestionnaire(input: $input) {
      title
      description
      info
      position
      id
      questions {
        title
        identifier
        position
        description
        info
        iconName
        fieldGroups {
          title
          key
        }
        constraints {
          scope
          reference
          minValue
          maxValue
          warningMessage
        }
        fields {
          title
          fieldGroupId
          fieldKey
          fieldValue
          fieldType
          fieldInputType
          fieldDefaultValue
          fieldMin
          fieldMax
          values
          enabled
          onAction {
            fieldValueChange {
              newValue
              states {
                fieldKey
                fieldValue
                fieldMax
                fieldMin
                fieldInputType
                fieldKeyGroup
                enabled
              }
            }
          }
          iconName
        }
      }
    }
  }
`);

const TopologyCopyAction = graphql(`
  query ($input: GetTopologyCopyActionInput!) {
    topologyCopyAction(input: $input)
  }
`);

const GetCommissioningCostNodeQry = graphql(`
  query getCommissioningCostNode($input: GetCommissioningCostNodeInput!) {
    getCommissioningCostNode(input: $input) {
      id
      folderName
      active
      kind
      position
      quantity
    }
  }
`);

export {
  FetchWizardStepQuestionnaire,
  TopologyCopyAction,
  FetchWizardQry,
  GetCommissioningCostNodeQry,
};
